(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rocketz-cashback-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rocketz-cashback-estimate')) {
    customElements.define(
      'rocketz-cashback-estimate',
      class extends HTMLElement {
        connectedCallback() {
          this.renderEstimate();
        }

        async renderEstimate() {
          const amount = Math.max(0, Number(this.dataset.amount || 0) / 100);
          if (!amount) return;
          try {
            const response = await fetch(
              `/apps/rocketz-license/cashback/estimate?amount=${Math.round(amount * 100)}`,
              { headers: { accept: 'application/json' } },
            );
            if (!response.ok) return;
            const config = await response.json();
            if (!config.enabled || !config.rewardAmount) return;
            const currency = this.dataset.currency || 'USD';
            const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency,
            }).format(config.rewardAmount);
            this.querySelector('[data-cashback-message]').textContent = (
              this.dataset.message || 'Earn __amount__ cashback'
            ).replace('__amount__', formatted);
            this.querySelector('[data-cashback-delay]').textContent = (
              this.dataset.delay || 'Available after __days__ days'
            ).replace('__days__', String(config.holdDays));
            this.hidden = false;
          } catch (_error) {
            this.hidden = true;
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
